import FieldReadOnly from "../../../generic/read-only-value/read-only"
import FieldConfig from "../../../proto/field-config"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import {EntityType} from "../../../../gd/const/item"
import FieldNumber_BoardAggregate from "../../../generic/number/render/aggregate/board-aggregate"

export default class FieldNumberOfTasks extends FieldReadOnly {

    constructor(config: FieldConfig) {
        super(config)

        this.label                              = "Number of tasks"
        this.icon                               = 'i5-task'

        this.hasCalculatedValues                = true

        this.renderComponents.boardAggregate    = FieldNumber_BoardAggregate
    }

    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    getAggregateValue_V2(model: any): any {
        return model.entityType === EntityType.TASK ? 1 : 0
    }
}
